import _ from 'lodash'
import MenuItem from './MenuItem'

// Module-level state. MenuItem instances live here — they cannot be stored in
// Redux because they carry circular parent references and class methods.
const data = {
  item: undefined,
  items: [],
}

// Lightweight event emitter (replaces Reflux.createStore).
const listeners = []

const NavigationStore = {
  /** Subscribe to navigation changes. Returns an unsubscribe function. */
  listen(fn) {
    listeners.push(fn)
    return function unsubscribe() {
      const i = listeners.indexOf(fn)
      if (i > -1) listeners.splice(i, 1)
    }
  },

  trigger(payload) {
    listeners.forEach(fn => fn(payload))
  },

  getData() {
    return data
  },

  getInitialState() {
    return data
  },

  /** Called by NavigationActions.initWithRawItems */
  onInitWithRawItems(rawItems) {
    data.items = _.map(rawItems, item => new MenuItem(item))
    _setInitialItem(data.items)
    NavigationStore.trigger({ items: data.items })
  },

  /** Called by NavigationActions.activate */
  onActivate(item) {
    data.item = item
    if (item.route) {
      NavigationStore.trigger({ item, items: data.items })
    }
  },
}

function _setInitialItem(items) {
  items.forEach(item => {
    if (item.isActive) {
      data.item = item
    }
    if (item.items) {
      _setInitialItem(item.items)
    }
  })
}

export default NavigationStore

